import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { PhoneInput } from 'react-international-phone';
import { PHONE_COUNTRIES, FLAG_IMAGES } from 'src/constants/phone.constants';
import useLayout from 'src/providers/LayoutProvider/Layout.hook.tsx';
import useAddWorkspaceModal from './AddWorkspaceModal.hook.ts';
import { isUndefined } from 'lodash';
import { useUserContext } from '../../../../../providers/UserProvider/User.context.ts';

export function AddWorkspaceModalForm() {
  const { addWorkspaceFormik, IndustryTypesList } = useAddWorkspaceModal();
  const { currentUser } = useUserContext();
  const { currentTheme } = useLayout();

  const { t } = useTranslation('sidebar/sidebarComponent');

  const phoneInputClass = currentTheme === 'dark' ? 'darkTheme' : '';
  const industriesArray = IndustryTypesList?.types || [];

  if (isUndefined(addWorkspaceFormik)) {
    return <></>;
  }

  return (
    <form
      onSubmit={addWorkspaceFormik.handleSubmit}
      className="AddWorkspace__Modal__Form"
    >
      <div className="AddWorkspace__Modal__Form__Row">
        <label className="AddWorkspace__Modal__Form__Label">
          {t('page.modals.addWorkspace.companyName')}
        </label>
        <input
          type="text"
          name="companyName"
          value={addWorkspaceFormik.values.companyName}
          onChange={addWorkspaceFormik.handleChange}
          onBlur={addWorkspaceFormik.handleBlur}
          placeholder={t('page.modals.addWorkspace.companyNamePlaceholder')}
          className="AddWorkspace__Modal__Form__Input"
        />
        {addWorkspaceFormik.touched.companyName &&
        addWorkspaceFormik.errors.companyName ? (
          <div className="AddWorkspace__Modal__Form__Error">
            {addWorkspaceFormik.errors.companyName}
          </div>
        ) : null}
      </div>
      <div className="AddWorkspace__Modal__Form__Row">
        <label className="AddWorkspace__Modal__Form__Label">
          {t('page.modals.addWorkspace.companyType')}
        </label>
        <select
          name="companyType"
          value={addWorkspaceFormik.values.companyType}
          onChange={addWorkspaceFormik.handleChange}
          onBlur={addWorkspaceFormik.handleBlur}
          className="AddWorkspace__Modal__Form__Select"
        >
          <option value="" disabled>
            {t('page.modals.addWorkspace.selectCompanyTypeTitle')}
          </option>
          {industriesArray?.map((industry, index) => (
            <option key={index} value={industry.id}>
              {industry.name}
            </option>
          ))}
        </select>
        {addWorkspaceFormik.touched.companyType &&
        addWorkspaceFormik.errors.companyType ? (
          <div>{addWorkspaceFormik.errors.companyType}</div>
        ) : null}
      </div>

      {!currentUser?.phoneNumber && (
        <>
          <div className="AddWorkspace__Modal__Form__Row">
            <label className="AddWorkspace__Modal__Form__Label">
              {t('page.modals.addWorkspace.phoneNumber')}
            </label>
            <PhoneInput
              name="phoneNumber"
              countries={PHONE_COUNTRIES}
              flags={FLAG_IMAGES}
              defaultCountry="mx"
              className={`AddWorkspace__Modal__Form__PhoneInput ${phoneInputClass}`}
              onChange={(value, meta) => {
                addWorkspaceFormik.setFieldValue('phoneNumber', value);
                addWorkspaceFormik.setFieldValue(
                  'countryCode',
                  meta.country.iso2.toUpperCase(),
                );
              }}
            />

            {addWorkspaceFormik.touched.phoneNumber &&
            addWorkspaceFormik.errors.phoneNumber ? (
              <div>{addWorkspaceFormik.errors.phoneNumber}</div>
            ) : null}
            {addWorkspaceFormik.touched.countryCode &&
            addWorkspaceFormik.errors.countryCode ? (
              <div>{addWorkspaceFormik.errors.countryCode}</div>
            ) : null}
          </div>
        </>
      )}

      <Button
        disabled={
          !addWorkspaceFormik.isValid || addWorkspaceFormik.isSubmitting
        }
        color="primary"
        loading={addWorkspaceFormik.isSubmitting}
        type="submit"
        className="AddWorkspace__Modal__Form___Button"
      >
        {t('page.modals.addWorkspace.submitButton')}
      </Button>
    </form>
  );
}
